/**
 * @author       samuel@zumper.com (Samuel Shih)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  trackFloorplanEvent.js
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import { FLOORPLAN_CLICK } from '@zcode-ui/web-zumper-integrations'
import type { ListingAmenity } from '@zcode/enums'
import type { FloorplanListing } from '@zcode/state-type'
import type { TitleCase } from '@zcode/utils'
import type { Dispatch } from 'redux'

import type { GetState } from '../../../modules/types'
import { trackMightBeDetailEvent } from './trackMightBeDetailEvent'

export interface FloorplanInfo {
  bathrooms: number
  amenities: readonly ListingAmenity[] | null
  bedrooms: number
  buildingId: number
  halfBathrooms: number
  minPrice: number | null | undefined
  maxPrice: number | null | undefined
  squareFeet: number | undefined
}

const getFloorplanInfo = (floorplan: FloorplanListing) => {
  if (!floorplan) {
    return null
  }

  const {
    bathrooms,
    amenities,
    bedrooms,
    buildingId,
    halfBathrooms,
    minPrice,
    maxPrice,
    squareFeet,
  } = floorplan
  return {
    bathrooms,
    amenities,
    bedrooms,
    buildingId,
    halfBathrooms,
    minPrice,
    maxPrice,
    squareFeet,
  }
}

interface TrackFloorplanEventProps {
  action:
    | 'Show Floorplan Summary'
    | 'Show Floorplans Close'
    | 'Show Floorplan Expand'
    | 'View Details Close'
    | 'View Details Expand'
  floorplans: readonly FloorplanListing[]
  title:
    | TitleCase<Exclude<FloorplanListing['bedText'], ''> | 'room'>
    | Exclude<FloorplanListing['title'], undefined>
}

export const trackFloorplanEvent =
  ({ action, floorplans, title }: TrackFloorplanEventProps) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const user = getUser(state)
    const floorplanInfo = floorplans.map((floorplan) => {
      return getFloorplanInfo(floorplan)
    })

    const additionalProps = { action, floorplanInfo, title }

    dispatch(trackMightBeDetailEvent({ additionalProps, name: FLOORPLAN_CLICK, user }))
  }
